<div class="page-outer-wrapper">

  <div class="admin-page-header">
    <div class="hamburger">
      <img (click)="toggleSidebar()" style="cursor: pointer;" src="/assets/images/menu-512.png" height="28" width="28">
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>

  <div class="page-content-background">

    <div class="page-content">

      <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

        <mat-sidenav #adminsidenav class="admin-sidebar">

          <admin-sidebar></admin-sidebar>

        </mat-sidenav>

        <mat-sidenav-content>

          <!-- [START] page content -->

          <mat-card style="width: 100%; display: block;">

            <mat-card-header>
              <mat-card-title>Administration - General</mat-card-title>
            </mat-card-header>

            <mat-card-content>

              <mat-grid-list cols="4" >

                <mat-grid-tile>
                  <a title="Panorama Synchronization" mat-list-item [routerLink]="['/administration/sync']"><img src="assets/images/sync-db.png" width="120"></a>
                  <div>
                    <label>Sync</label>
                  </div>
                </mat-grid-tile>

                <mat-grid-tile>
                  <a title="Approve Pending Users"  mat-list-item [routerLink]="['/administration/users/pending']"><img src="assets/images/approve-user.png" width="120"></a>
                  <div>
                    <label>Pending: {{pendingCount}}</label>
                  </div>
                </mat-grid-tile>

                <mat-grid-tile>
                  <a title="Manage All Users"  mat-list-item [routerLink]="['/administration/users']"><img src="assets/images/manage-users.png" width="120"></a>
                  <div>
                    <label>Users: {{userCount}}</label>
                  </div>
                </mat-grid-tile>

                <mat-grid-tile>
                  <a title="Create a User" mat-list-item [routerLink]="['/administration/users/new']"><img src="assets/images/create-user.png" width="120"></a>
                </mat-grid-tile>

              </mat-grid-list>

            </mat-card-content>
          </mat-card>


        </mat-sidenav-content>

      </mat-sidenav-container>

    </div>

    <div id="pano-footer" class="pano-footer"></div>
  </div>

</div>
